import { useEffect } from "react";

interface PageMetaProps {
  readonly title: string;
  readonly description: string;
  readonly noIndex?: boolean;
}

export function PageMeta({ title, description, noIndex = false }: PageMetaProps) {
  useEffect(() => {
    document.title = `${title} · StudyCoach`;
    document.querySelector('meta[name="description"]')?.setAttribute("content", description);
    let robots = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    const created = !robots;
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.append(robots);
    }
    robots.content = noIndex ? "noindex, nofollow" : "index, follow";
    return () => {
      if (created) robots?.remove();
    };
  }, [description, noIndex, title]);
  return null;
}
